import gql from 'graphql-tag';

export const setPinStateMutation = gql`
  mutation setPinState($id: String!, $pin: Boolean!, $targetId: String!) {
    setPinState(id: $id, pin: $pin, targetId: $targetId) {
      ok
      error
      node {
        ... on Node {
          id
          pins
        }
      }
    }
  }
`;

export const updateGroupMutation = gql`
  mutation updateGroup($id: String!, $name: String!, $emoji: String) {
    updateGroup(id: $id, name: $name, emoji: $emoji) {
      ok
      error
      groups {
        id
        name
        emoji
        isAdmin
        groupType
        members {
          ... on Person {
            id
            name
            avatarUrl
          }
        }
      }
    }
  }
`;

export const createGroupMutation = gql`
  mutation createGroup($name: String!, $uuid: String!, $emoji: String!) {
    createGroup(name: $name, uuid: $uuid, emoji: $emoji) {
      ok
      error
      groups {
        id
        name
        emoji
        isAdmin
        groupType
        members {
          ... on Person {
            id
            name
            avatarUrl
          }
        }
      }
    }
  }
`;

export const addGroupMemberMutation = gql`
  mutation addGroupMember($groupId: String!, $personId: String!) {
    addGroupMember(id: $groupId, personId: $personId) {
      ok
      error
      groups {
        id
        name
        emoji
        isAdmin
        groupType
        members {
          ... on Person {
            id
            name
            avatarUrl
          }
        }
      }
    }
  }
`;
export const addGroupMemberModalMutation = gql`
  mutation addGroupMember($groupId: String!, $personId: String!) {
    addGroupMember(id: $groupId, personId: $personId) {
      ok
      error
    }
  }
`;

export const addGroupMemberOptimisticMutation = gql`
  mutation addGroupMember($groupId: String!, $personId: String!) {
    addGroupMember(id: $groupId, personId: $personId) {
      ok
      error
    }
  }
`;

export const removeGroupMemberMutation = gql`
  mutation removeGroupMember($id: String!, $personId: String!) {
    removeGroupMember(id: $id, personId: $personId) {
      ok
      error
      groups {
        id
        name
        emoji
        isAdmin
        groupType
        members {
          ... on Person {
            id
            name
            avatarUrl
          }
        }
      }
    }
  }
`;

export const removeGroupMutation = gql`
  mutation removeGroup($id: String!) {
    removeGroup(id: $id) {
      ok
      error
      groups {
        id
        name
        emoji
        isAdmin
        groupType
        members {
          ... on Person {
            id
            name
            avatarUrl
          }
        }
      }
    }
  }
`;

// TODO-506 add to get percentage from group response and add more fields to get from group for optimistic
export const addMultipleNodesToGroup = gql`
  mutation shareNodesMany($ids: [String]!, $targetId: String!) {
    shareNodesMany(ids: $ids, targetId: $targetId) {
      ok
      error
      successRate
      group {
        id
        nodeCount
      }
    }
  }
`;
